module.exports = __webpack_public_path__ + "img/phelpsa.10fa4831.jpg";